const hasWallet = (token) => {
    if (token) {
      return true
    }
  }

  export function disconnectWallet() {

      localStorage.removeItem('wallet');

  }
  
  export default hasWallet;
  